import {useQuery, UseQueryOptions} from "react-query";
import Alert from "react-s-alert";

import {
  FacilityWorkflowsResponse,
  WorkflowService,
} from "../../../services/WorkflowService";

export const facilityWorkflowsQueryKey = (
  facilityId?: string,
  templateId?: string,
) =>
  [
    "facilityWorkflows",
    facilityId ?? "default",
    templateId ?? "latest",
  ] as const;

type QueryConfig = Omit<
  UseQueryOptions<
    FacilityWorkflowsResponse,
    unknown,
    FacilityWorkflowsResponse,
    ReturnType<typeof facilityWorkflowsQueryKey>
  >,
  "queryKey" | "queryFn"
>;

/**
 * Loads enabled workflow types for a facility.
 *
 * When `facilityId` is omitted, falls back to admission only. When `templateId` is given,
 * workflows are loaded from that exact template version rather than the facility's latest
 * one — use this for an existing admission, whose template may no longer be the latest.
 */
export const useFacilityWorkflowsQuery = (
  facilityId?: string,
  templateId?: string,
  queryConfig: QueryConfig = {},
) =>
  useQuery(
    facilityWorkflowsQueryKey(facilityId, templateId),
    () => WorkflowService.getFacilityWorkflows(facilityId ?? "", templateId),
    {
      enabled: facilityId === undefined || Boolean(facilityId),
      onError: () =>
        Alert.error(
          "Failed to load workflows for this facility. Please, try again later.",
        ),
      ...queryConfig,
    },
  );
